export default __webpack_public_path__ + "dist/media/success-message.06901c4d.svg";